import React from 'react';

const ItemNotFound = () => {
    return (
        <div className='text-center w-3/4 mx-auto'>
            <img src="https://img.freepik.com/free-vector/tiny-people-examining-operating-system-error-warning-web-page-isolated-flat-illustration_74855-11104.jpg?t=st=1655615085~exp=1655615685~hmac=2d9f71731121645d4df9a5c3da858ee4ed06cf287d891382f06dbc394dfc7972&w=1380" alt="" />
            <h1 className='text-xl lg:text-4xl font-semibold text-orange-400 '>No Food Found</h1>
            <h2 className='text-xl lg:text-4xl font-semibold text-blue-800'>Try Different keyword</h2>
        </div>
    );
};

export default ItemNotFound;